import { createVanIconComponent } from "./van"

const YouzanShield = createVanIconComponent("youzan-shield")
export default YouzanShield
